// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__b-pLo","title":"styles_title__3G1xf"};